import React, { useRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';
import { white } from '../../../../../cra/src/styling/theme';
import {
  Campaign,
  Customization,
  Tutorial,
} from '../../../../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';

const CardsDiv = styled.div`
  color: black;
  grid-column-gap: 1.5rem;
  box-shadow: 0px 0px 16px rgba(15, 28, 53, 0.15);
  border-radius: 16px;
  background: ${white};
  opacity: 0;
  filter: blur(2px);
  transform: translateX(-10%);

  ${(props) => {
    if (props.elementVisibilty) {
      return css`
        opacity: 1;
        filter: blur(0);
        transform: translateX(0);
        transition: all 1.5s;
      `;
    }
    return null;
  }}

  width: 275px;
  margin: ${(props) =>
    props.index === 3 ? '0px 0px 2px 0px' : '0px 0px 20px 0px'};

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: ${(props) => (props.index > 1 ? '3/5' : '1/3')};
    grid-row: ${(props) => (props.index === 2 ? '1/2' : '')};
    width: 100%;
    margin: 0px 0px 20px 0px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 1/-1;
    margin: 0px;
    grid-row: ${(props) => (props.index === 2 ? '3/4' : '')};
    height: 100%;
    width: 413px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    width: 467px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    width: 571px;
  }

  ${({ higherEd }) => {
    if (higherEd) {
      return css`
        width: 70%;
        justify-items: center;
        grid-gap: 0;
        padding: 12px 6px 6px 6px;

        @media ${breakpointsMinWidth.mobileMd} {
          width: 70%;
        }
        @media ${breakpointsMinWidth.tabletSm} {
          display: grid;
          grid-template-columns: 80px 1fr;
          width: 70%;
          padding: 8px;
          padding: 12px 16px;
          min-height: 153px;
        }

        @media ${breakpointsMinWidth.tabletMd} {
          width: 70%;
          grid-template-columns: 100px 1fr;
          min-height: 144px;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          width: 70%;
          padding: 16px 20px;
          grid-template-columns: 134px 1fr;
          min-height: 150px;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          width: 70%;
          grid-template-columns: 160px 1fr;
          min-height: 222px;
        }
      `;
    }
    return null;
  }}
`;

const CardsHeadingp = styled.p`
  color: #4a4a4a;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 1.5rem;
  grid-column: 1/3;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  margin: 12px 13px 5px 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 12px;
    line-height: 20px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    margin: 14.96px 21.08px 3.74px 15.81px;
    font-size: 13px;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 14px;
    margin: 14.96px 21.08px 3.74px 15.81px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    margin: 16.91px 23.83px 4.23px 17.88px;
    font-size: 16px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: 32px 32px 22px 24px;
    font-size: 20px;
    line-height: 28px;
  }
`;

const CardsSubHeadingp = styled.p`
  color: #4a4a4a;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 1.5rem;
  grid-column: 1/13;

  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;

  align-items: center;
  margin: 0px 11px 12px 11px;

  @media ${breakpointsMinWidth.tabletSm} {
    line-height: 20px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    margin: 0px 15.81px 14.96px 15.81px;
    font-size: 13px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 14px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 14px;
    margin: 0px 17.88px 16.92px 17.88px;
    font-size: 16px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: 0px 24px 24px 24px;
    font-size: 20px;
    line-height: 28px;
  }
`;

const IconWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 96px;
    height: 96px;

    @media ${breakpointsMinWidth.desktopMd} {
      width: 120px;
      height: 120px;
    }
  }
`;

const Card = ({ index, child, higherEd }) => {
  const myref = useRef();
  const [elementVisibilty, setMyElementVisible] = useState();
  const { heading, subHeading, Key } = child;

  const handleObserverCallBack = (entries) => {
    const entry = entries[0];
    if (entry.intersectionRatio >= 0.2 && entry.isIntersecting) {
      setMyElementVisible(entry.isIntersecting);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserverCallBack, {
      threshold: [0, 0.2],
    });
    observer.observe(myref.current);
  }, []);

  const getIcon = (key) => {
    switch (key) {
      case 1:
        return <Customization />;
      case 2:
        return <Campaign />;
      case 3:
        return <Tutorial />;
      default:
        return <Customization />;
    }
  };

  return (
    <>
      <CardsDiv
        higherEd={higherEd}
        ref={myref}
        elementVisibilty={elementVisibilty}
        index={index}
      >
        {higherEd && <IconWrap>{getIcon(Key)}</IconWrap>}
        <div>
          <CardsHeadingp>{heading}</CardsHeadingp>
          <CardsSubHeadingp>{subHeading}</CardsSubHeadingp>
        </div>
      </CardsDiv>
    </>
  );
};

export default Card;
